export default __webpack_public_path__ + "i18n/nl.66510b8037c7504e50790d1795a0925a.json";